import React from "react";
import "../../../styles/home1.css";

const salesOrdersData = [
  {
    id: 1,
    customer: "Jane Cooper",
    company: "Microsoft",
    phone: "(225) 555-0118",
    email: "jane@microsoft.com",
    country: "United States",
    status: "Active"
  },
  {
    id: 2,
    customer: "Floyd Miles",
    company: "Yahoo",
    phone: "(205) 555-0100",
    email: "floyd@yahoo.com",
    country: "Kiribati",
    status: "Inactive"
  }
];

export default function SalesOrders() {
  return (
    <div className="card shadow-sm border-0 h-100">
      <div className="card-body">

        <div className="d-flex justify-content-between align-items-center mb-4">

          <h6 className="card-title fw-bold mb-0">Sales Order</h6>

          <div className="d-flex gap-2">

            <input
              type="text"
              className="form-control form-control-sm bg-light border-0"
              placeholder="Search"
              style={{ width: 150 }}
            />

            <select
              className="form-select form-select-sm bg-light border-0"
              style={{ width: 120 }}
            >
              <option>Newest</option>
            </select>

          </div>

        </div>

        <div className="table-responsive">

          <table className="table table-borderless align-middle mb-0">

            <thead className="text-muted small text-uppercase">
              <tr>
                <th className="fw-medium ps-0">Customer Name</th>
                <th className="fw-medium">Company</th>
                <th className="fw-medium">Phone Number</th>
                <th className="fw-medium">Email</th>
                <th className="fw-medium">Country</th>
                <th className="fw-medium text-end pe-0">Status</th>
              </tr>
            </thead>

            <tbody>

              {salesOrdersData.map((order) => (
                <tr
                  key={order.id}
                  style={{ borderBottom: "1px solid #f0f0f0" }}
                >

                  <td className="ps-0 py-3 fw-bold small">
                    {order.customer}
                  </td>

                  <td className="py-3 small text-muted">
                    {order.company}
                  </td>

                  <td className="py-3 small text-muted">
                    {order.phone}
                  </td>

                  <td className="py-3 small text-muted">
                    {order.email}
                  </td>

                  <td className="py-3 small text-muted fw-bold">
                    {order.country}
                  </td>

                  <td className="pe-0 text-end">

                    <span
                      className={`badge rounded-pill fw-normal ${
                        order.status === "Active"
                          ? "bg-success bg-opacity-10 text-success"
                          : "bg-danger bg-opacity-10 text-danger"
                      }`}
                    >
                      {order.status}
                    </span>

                  </td>

                </tr>
              ))}

            </tbody>

          </table>

        </div>

      </div>
    </div>
  );
}